import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { BaseService } from '../../../services/Base.service';


@Injectable({
    providedIn: 'root'
})
export class SistemaMenuService extends BaseService {
    constructor() {
        super('/SistemaMenu/')
    }

    getMenus(): Observable<any> {
        const url = 'Menus';
        return this._http.get(`${this._config.baseUrl}${this._api}${url}`);
    }
}
